var map = {
	"./Stroke 1.png": 1278,
	"./Why Our Save the Dat.png": 1279,
	"./all_about_shipping@2x.png": 1280,
	"./ask_for_everything@2x.png": 1281,
	"./big-day@1x.png": 1282,
	"./big-day@2x.png": 1283,
	"./birds@1x.png": 1284,
	"./birds@2x.png": 1285,
	"./check-list@1x.png": 1286,
	"./check-list@2x.png": 1287,
	"./circle-better@1x.png": 1288,
	"./circle-better@2x.png": 1289,
	"./empty_rsvp.png": 1290,
	"./empty_rsvp2x.png": 1291,
	"./envelope.png": 781,
	"./envelope.svg": 1292,
	"./envelope@2x.png": 1293,
	"./events_doodle.png": 565,
	"./events_doodle.svg": 1294,
	"./gifts@1x.png": 1295,
	"./gifts@2x.png": 1296,
	"./guest-list@1x.png": 1297,
	"./guest-list@2x.png": 1298,
	"./guest.png": 1299,
	"./guest.svg": 1300,
	"./guest2x.png": 1301,
	"./guest_approved@2x.png": 1302,
	"./invitations@1x.png": 1303,
	"./invitations@2x.png": 1304,
	"./invites_paper.svg": 1305,
	"./invites_paper@1x.png": 1306,
	"./invites_paper@2x.png": 1307,
	"./laptop-one-heart.png": 1308,
	"./laptop-one-heart@2x.png": 1309,
	"./laptop@1x.png": 1310,
	"./laptop@2x.png": 1311,
	"./long-page-checklist.png": 1312,
	"./long-page-checklist@2x.png": 1313,
	"./make_it_personal@2x.png": 1314,
	"./namecard-with-name.png": 1315,
	"./namecard-with-name@2x.png": 1316,
	"./namecard_no_name.svg": 566,
	"./namecard_with_name.svg": 1317,
	"./namecard_with_question_marks.svg": 360,
	"./no_address.png": 1318,
	"./no_address2x.png": 1319,
	"./onboarding_1.png": 1320,
	"./onboarding_1@2x.png": 1321,
	"./onboarding_2.png": 1322,
	"./onboarding_2@2x.png": 1323,
	"./onboarding_3.png": 1324,
	"./onboarding_3@2x.png": 1325,
	"./onboarding_4.png": 1326,
	"./onboarding_4@2x.png": 1327,
	"./red-star-left@1x.png": 1328,
	"./red-star-left@2x.png": 1329,
	"./red-star-right@1x.png": 1330,
	"./red-star-right@2x.png": 1331,
	"./registry_publish_champagne.svg": 1332,
	"./rsvp@1x.png": 1333,
	"./rsvp@2x.png": 1334,
	"./save-the-date@1x.png": 1335,
	"./save-the-date@2x.png": 1336,
	"./sparkle-left.svg": 757,
	"./sparkle-right.svg": 758,
	"./sparkle-up.svg": 782,
	"./ta-da.png": 1337,
	"./ta-da@2x.png": 1338,
	"./talk.svg": 1339,
	"./talk@1x.png": 759,
	"./talk@2x.png": 760,
	"./timeline-line-dark@1x.png": 1340,
	"./timeline-line-dark@2x.png": 1341,
	"./timeline-line@1x.png": 1342,
	"./timeline-line@2x.png": 1343,
	"./tips.svg": 761,
	"./underline_long@1x.png": 1344,
	"./underline_long@2x.png": 1345,
	"./underline_sm@1x.png": 1346,
	"./underline_sm@2x.png": 1347,
	"./website_publish_confetti.svg": 567,
	"./wedding-websites@1x.png": 1348,
	"./wedding-websites@2x.png": 1349,
	"./wedding_help.png": 783,
	"./wedding_help.svg": 1350,
	"./wedding_help@2x.png": 1351
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 359;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 359
// module chunks = 50